module.exports = __webpack_public_path__ + "img/SmallGuns.499502bc.png";